







import { Component, Vue } from 'vue-property-decorator';
import Repeater from '@/components/Repeater.vue';

@Component({
    components: { Repeater }
})
export default class Klokjes extends Vue {
}
